import axios from "axios";

const BACKEND_URL = process.env.REACT_APP_BACKEND_URL;
export const API = `${BACKEND_URL}/api`;

export const api = axios.create({
  baseURL: API,
  withCredentials: true,
});

export const LOGO_URL =
  "https://customer-assets-jai6qajn.emergentagent.net/job_51dbd104-c7e1-44b4-814a-4f6162bb5d2c/artifacts/j341v85s_jDwrN.jpg";
export const LOGO_TRANSPARENT =
  "https://customer-assets-jai6qajn.emergentagent.net/job_51dbd104-c7e1-44b4-814a-4f6162bb5d2c/artifacts/0ifqwl3e_fOrfm.jpg";
// Custom-generated Miami sunset hero (silhouette freshener + Ocean Drive vibes)
export const HERO_CAR = "/hero-miami.png";

/**
 * Resolve a product image URL. Backend can return either an absolute URL
 * or a path like /api/files/... which we prefix with the backend URL.
 * Pass `w` (px) to request an on-the-fly-resized WebP thumbnail — cuts
 * mobile payload ~70% and improves Core Web Vitals / LCP scores.
 * Pass `removeBg: true` to strip the studio background server-side so
 * the freshener renders as a clean transparent PNG floating in mid-air.
 * Absolute URLs on other origins pass through untouched.
 */
export function resolveImage(url, w, opts = {}) {
  const removeBg = opts && opts.removeBg;
  if (!url) return LOGO_URL;
  const full = url.startsWith("http") ? url : `${BACKEND_URL}${url}`;
  if (!full.includes("/api/files/")) return full;
  const params = [];
  if (w) params.push(`w=${w}`);
  if (removeBg) params.push("nobg=1");
  if (params.length === 0) return full;
  const sep = full.includes("?") ? "&" : "?";
  return `${full}${sep}${params.join("&")}`;
}
